/**
 * @generated SignedSource<<afc931cc3ec0d0560180b21f80cc4347>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type APPROVAL_STATUS = "APPROVED" | "SUBMITTED" | "NOT_SUBMITTED" | "PENDING" | "DECLINED" | "INVOICED" | "%future added value";
export type APPROVAL_TYPE = "SUBMIT_TIME_OFF" | "SUBMIT" | "APPROVE" | "FORCE_APPROVE" | "UNSUBMIT" | "UNAPPROVE" | "RESUBMIT" | "DECLINE" | "REVERSE_APPROVAL" | "INVOICE" | "%future added value";
export type TIME_REG_APPROVAL_LOG_ACTOR_SOURCE = "USER" | "SYSTEM" | "%future added value";
export type TIME_REG_APPROVAL_LOG_EVENT_TYPE = "STATUS_CHANGE" | "INVOICE_LINK" | "INVOICE_UNLINK" | "FIELD_EDIT" | "%future added value";
export type TIME_REG_AUDIT_FIELD = "LOGGED_AGAINST" | "MINUTES_REGISTERED" | "DATE" | "NOTES" | "BILLABLE_MINUTES_REGISTERED" | "ROLE" | "PERSON" | "RETAINER_CONFLICT_HANDLED" | "%future added value";
export type ApprovalLogDrawerQuery$variables = {
  ids: ReadonlyArray<string>;
};
export type ApprovalLogDrawerQuery$data = {
  readonly nodes: ReadonlyArray<{
    readonly id?: string;
    readonly date?: string | null;
    readonly year?: number | null;
    readonly month?: number | null;
    readonly day?: number | null;
    readonly minutesRegistered?: number | null;
    readonly approvalStatus?: APPROVAL_STATUS | null;
    readonly project?: {
      readonly id: string;
      readonly name: string | null;
      readonly projectColor: string | null;
      readonly companyProjectId: number | null;
      readonly customProjectId: string | null;
    } | null;
    readonly idleTime?: {
      readonly name: string | null;
      readonly isInternalTime: boolean | null;
    } | null;
    readonly task?: {
      readonly name: string | null;
      readonly companyTaskId: number | null;
      readonly project: {
        readonly id: string;
        readonly name: string | null;
        readonly projectColor: string | null;
        readonly companyProjectId: number | null;
        readonly customProjectId: string | null;
      } | null;
    } | null;
    readonly approvalLog?: ReadonlyArray<{
      readonly id: string | null;
      readonly batchId: string | null;
      readonly batchScope: {
        readonly dayCount: number | null;
        readonly periodStart: string | null;
        readonly periodEnd: string | null;
      } | null;
      readonly eventType: TIME_REG_APPROVAL_LOG_EVENT_TYPE | null;
      readonly approvalType: APPROVAL_TYPE | null;
      readonly fromStatus: APPROVAL_STATUS | null;
      readonly toStatus: APPROVAL_STATUS | null;
      readonly actor: {
        readonly id: string;
        readonly firstName: string | null;
        readonly lastName: string | null;
        readonly profilePictureId: string | null;
      } | null;
      readonly actorSource: TIME_REG_APPROVAL_LOG_ACTOR_SOURCE | null;
      readonly reason: string | null;
      readonly isBypassEdit: boolean | null;
      readonly createdAt: string | null;
      readonly invoice: {
        readonly id: string;
      } | null;
      readonly invoiceNumber: number | null;
      readonly invoiceDeleted: boolean | null;
      readonly fieldName: TIME_REG_AUDIT_FIELD | null;
      readonly oldValue: string | null;
      readonly newValue: string | null;
      readonly oldLabel: string | null;
      readonly newLabel: string | null;
      readonly isMaterial: boolean | null;
    }> | null;
  } | null>;
};
export type ApprovalLogDrawerQuery = {
  variables: ApprovalLogDrawerQuery$variables;
  response: ApprovalLogDrawerQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ids"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "ids",
    "variableName": "ids"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "day",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minutesRegistered",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approvalStatus",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectType",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyProjectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customProjectId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInternalTime",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyTaskId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "TimeRegApprovalLogEntry",
  "kind": "LinkedField",
  "name": "approvalLog",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "batchId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TimeRegAuditBatchScope",
      "kind": "LinkedField",
      "name": "batchScope",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dayCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "periodStart",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "periodEnd",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "approvalType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fromStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "actor",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "profilePictureId",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actorSource",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isBypassEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InvoiceType",
      "kind": "LinkedField",
      "name": "invoice",
      "plural": false,
      "selections": [
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "invoiceNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "invoiceDeleted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fieldName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "oldValue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "newValue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "oldLabel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "newLabel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMaterial",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ApprovalLogDrawerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "IdleTime",
                "kind": "LinkedField",
                "name": "idleTime",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Task",
                "kind": "LinkedField",
                "name": "task",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v12/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              (v13/*: any*/)
            ],
            "type": "TimeRegType",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ApprovalLogDrawerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "IdleTime",
                "kind": "LinkedField",
                "name": "idleTime",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v11/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Task",
                "kind": "LinkedField",
                "name": "task",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v12/*: any*/),
                  (v10/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v13/*: any*/)
            ],
            "type": "TimeRegType",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "864d338e25008877fe6b1b2532a64436",
    "id": null,
    "metadata": {},
    "name": "ApprovalLogDrawerQuery",
    "operationKind": "query",
    "text": "query ApprovalLogDrawerQuery(\n  $ids: [ID!]!\n) {\n  nodes(ids: $ids) {\n    __typename\n    ... on TimeRegType {\n      id\n      date\n      year\n      month\n      day\n      minutesRegistered\n      approvalStatus\n      project {\n        id\n        name\n        projectColor\n        companyProjectId\n        customProjectId\n      }\n      idleTime {\n        name\n        isInternalTime\n        id\n      }\n      task {\n        name\n        companyTaskId\n        project {\n          id\n          name\n          projectColor\n          companyProjectId\n          customProjectId\n        }\n        id\n      }\n      approvalLog {\n        id\n        batchId\n        batchScope {\n          dayCount\n          periodStart\n          periodEnd\n        }\n        eventType\n        approvalType\n        fromStatus\n        toStatus\n        actor {\n          id\n          firstName\n          lastName\n          profilePictureId\n        }\n        actorSource\n        reason\n        isBypassEdit\n        createdAt\n        invoice {\n          id\n        }\n        invoiceNumber\n        invoiceDeleted\n        fieldName\n        oldValue\n        newValue\n        oldLabel\n        newLabel\n        isMaterial\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0ebc058c5611b723ba037fb38c207456";

export default node;
